module.exports = __webpack_public_path__ + "style/img/智慧运维系统.09336302.jpg";